export default "__VITE_ASSET__BQNu$6Jk__"